import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import MuiSelect from '@mui/material/Select'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import MenuItem from '@mui/material/MenuItem'
import Box from '@mui/material/Box'

import {pickAttributes} from '../../../../helpers/utils'

const useStyles = makeStyles(selectStyles)

export default function Select (props) {

  const classes = useStyles()

  const controlAttributes = pickAttributes(props, 'control')
  const selectAttributes = pickAttributes(props, 'select')

  const errorId = `${props.id}-error-text`
  const labelId = `${props.id}-label`

  return (
    <Box className={clsx(classes.root, props.className)}>
      <Box className={clsx(classes.label, "label")}>{props.caption}:</Box>
      <Box className={clsx(classes.input, "input")}>
        <FormControl
          {...controlAttributes}
          className={classes.control}
        >
          <MuiSelect
            labelId={labelId}
            id={props.id}
            {...selectAttributes}
            className={clsx(classes.select, "select")}
          >
            {props.options.map((option, key) => (
              <MenuItem value={props.mapValue(option)} key={key}>{props.mapText(option)}</MenuItem>)
            )}
          </MuiSelect>
          <FormHelperText id={errorId} {...pickAttributes(props, 'error')}>{props.errorMessage}</FormHelperText>
        </FormControl>
      </Box>
    </Box>
  )
}


function selectStyles(theme) {
  return {
    root: {
    },
    control: {
      margin: 0,
      flexGrow: 1
    }
  }
}
